import { defineComponent as _defineComponent } from 'vue'
import { IReward } from '../models/reward'
import { KdButton, KdNoData } from 'kuaidong-ui'
import RewardTransImage from './RewardTransImage.vue'
import LotteryRewardImage from './LotteryRewardImage.vue'
import { lotteryRewardListDataKey } from '../service/lotteryService'


export default /*#__PURE__*/_defineComponent({
  __name: 'Rewards',
  props: {
    rewards: null,
    emptyText: { default: '— 当前还没有奖品 —' },
    hideAvatar: { type: Boolean },
    hideDisabledBtn: { type: Boolean }
  },
  emits: ['jump-to-target'],
  setup(__props: any, { emit: emits }) {





function getLotteryTag(_reward: IReward) {
  return _reward.data?.[lotteryRewardListDataKey] || ''
}

async function jumpToTarget(reward: IReward) {
  await reward.action?.()
  emits('jump-to-target', reward)
}

return { __sfc: true,emits, getLotteryTag, jumpToTarget, KdButton, KdNoData, RewardTransImage, LotteryRewardImage }
}

})